var locationsObject = null;
var phoneNumber;
var pageType; // should be 'state', 'locations', or 'single' ('single' not used at this time)
var contactUrl;
var mapInfoWindow;
var minNumMarkersToShow = 9;
var markersToShow = [];
var googleMapsReady = false;

onmessage = function(msg) {
  if (!msg.isTrusted) {
    console.log('Locations worker received message from untrusted source.');
    console.log(msg);
    return;
  }

  //console.log(msg);
  switch (msg.data.operation) {
    case 'init':
      locationsObject = JSON.parse(msg.data.locStr);
      phoneNumber = msg.data.phone;
      pageType = msg.data.pageType;
      contactUrl = msg.data.contactUrl;

            this.postMessage({ operation: 'locParsed', locations: locationsObject });
            if (googleMapsReady)
                initMap();

            // send first page of location html
            var htmlResp = getLocationPageHtml(pageType == 'state' ? -1 : 1);
            this.postMessage({ operation: 'locPageHtml', pageHtml: htmlResp.pageHtml, hasMore: htmlResp.hasMore });
            break;

        case 'getLocPageHtml':
            var htmlResp = getLocationPageHtml(msg.data.pageNum);
            this.postMessage({ operation: 'locPageHtml', pageHtml: htmlResp.pageHtml, clearPrevious: false, hasMore: htmlResp.hasMore });
            break;

        case 'googleMapsReady':
            googleMapsReady = true;
            if (locationsObject != null)
                initMap();
            break;

        case 'sortLocations':
            sortLocationsByDistance(msg.data.centerOn);

            var htmlResp = getLocationPageHtml(pageType == 'state' ? -1 : 1);
            this.postMessage({ operation: 'locPageHtml', pageHtml: htmlResp.pageHtml, clearPrevious: true, hasMore: htmlResp.hasMore });
            break;

        default:
            console.log('Locations worker received unknown operation: ' + msg.data.operation);
            console.log(msg.data);
	}
};


function getLocationPageHtml(pageNum) {
    var displayCount, startPos;

    if (pageNum == -1) { // do all locations
        displayCount = locationsObject.length;
        startPos = 0;
    } else { // do selected page, 9 locations per page
        displayCount = 9;
        startPos = (pageNum - 1) * displayCount;
	}

    var pageHtml = '';
    for (var i = startPos; i < startPos + displayCount; i++) {
        if (i >= locationsObject.length)
            break;
        else
            pageHtml += getLocationBlockHtml(i);
    }

    return {
        'pageHtml': pageHtml,
        'hasMore': pageNum == -1 ? false : locationsObject.length > pageNum * displayCount
    }
}

function getLocationBlockHtml(locKey) {

    var titleHtml;
    var name = locationsObject[locKey].name;
    var nameMobile = locationsObject[locKey].nameMobile;

    // if main locations page (not state page), and state code not already included
    // attach normalized state code
    if (pageType == 'locations') {
        var stateCodes = locationsObject[locKey].stateCodes;
        if (name.indexOf(stateCodes[0]) == -1)
            name += ', ' + stateCodes.join('/');
        if (nameMobile.indexOf(stateCodes[0]) == -1)
            nameMobile += ', ' + stateCodes.join('/');
    }

    if (pageType == 'state') {
        name = locationsObject[locKey].nameBare;
        nameMobile = locationsObject[locKey].nameMobile;
	}

    if (nameMobile == name)
        titleHtml = '<h4 class="title">' + name + '</h4>';
    else
        titleHtml = '<h4 class="title hide-for-xlarge">' + nameMobile + '</h4><h4 class="title show-for-xlarge">' + name + '</h4>';


    var pictureInnerHtml = '';

    // put image variants (if any) on page as <source> elements inside the <picture>
    var variants = locationsObject[locKey].photo.Variants;
    if (variants.hasOwnProperty("MarketImageWebP"))
        pictureInnerHtml += '<source type="image/webp" srcset="' + variants.MarketImageWebP + '">';
    if (variants.hasOwnProperty("MarketImage")) {
        var urlSplits = locationsObject[locKey].photo.Url.split('.');
        var mimeType = getImageMimeType(urlSplits[urlSplits.length - 1]); // get mime type from extension of the uploaded image
        pictureInnerHtml += '<source type="'+ mimeType + '" srcset="' + variants.MarketImage + '">';
    }

    // there will always be a fallback image
    pictureInnerHtml += '<img alt="' + locationsObject[locKey].photo.AltText + '" src="' + locationsObject[locKey].photo.Url + '">';

      
    return `
<div id="location-${locKey}" data-id="${locKey}" class="location-item small-12 large-6 xlarge-4 columns" data-loc-id="${locationsObject[locKey].id}">
    <a href="${locationsObject[locKey].link}" class="image-holder valign-wrapper">
        <picture>${pictureInnerHtml}</picture>
        ${titleHtml}
        <div class="overlay"></div>
    </a>
    <div class="text-wrapper">
        <a href="tel:1-${phoneNumber}" class="phone">${phoneNumber}</a>
        <div class="desc">
            ${locationsObject[locKey].desc}
        </div>
        <div class="links">
            <a href="${locationsObject[locKey].link}" class="link">View Location</a>
            <span class="sep">|</span>
            <a href="${contactUrl}" class="link">Contact Us</a>
        </div>
    </div>

    <div class="text-wrapper wrapper-b">
        <div class="icons-container">
            <div class="text-center trio-icon-width">
                <a href="tel:1-${phoneNumber}" class="circle-links">
                    <div class="circle-phone"></div>
                    <div>Call Now</div>
                </a>
            </div>
            <div class="text-center trio-icon-width">
                <a href="${locationsObject[locKey].link}" class="circle-links">
                    <div class="circle-pin"></div>
                    <div>View Location</div>
                </a>
            </div>
            <div class="text-center trio-icon-width">
                <a href="${contactUrl}" class="circle-links">
                    <div class="circle-check"></div>
                    <div>Get Started</div>
                </a>
            </div>
            <div class="desc-b text-center">${locationsObject[locKey].desc} </div>
            
        </div>
    </div>

</div>`;
}

function getImageMimeType(extension) {
    switch (extension.toLowerCase()) {
        case 'bmp':
            return 'image/bmp';
        case 'gif':
            return 'image/gif';
        case 'jpeg':
        case 'jpg':
            return 'image/jpeg';
        case 'png':
            return 'image/png';
        case 'svg':
            return 'image/svg+xml';
        case 'tif':
        case 'tiff':
            return 'image/tiff';
        case 'webp':
            return 'image/webp';
        default:
            return null;
	}
}

// sorts a global named locationsObject by proximity to provided lan/long position
function sortLocationsByDistance(pos) {

    //ASSIGN DISTANCE RELATIVE TO GEOLOCATED POSITION
    var dist;
    for (var key in locationsObject) {
        dist = distance(pos.lat, pos.lng, locationsObject[key]['lat'], locationsObject[key]['lng']);
        locationsObject[key]['dist'] = dist;
        //console.log('location ' + key + ': name - ' + locationsObject[key]['name'] + '; dist - ' + locationsObject[key]['dist']);
    }

    //SORT THE OBJECT BY NEW DISTANCES
    locationsObject = locationsObject.sort(function (a, b) {
        return a.dist - b.dist;
    });
}

function distance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist
}

function initMap() {

}
